import ServiceCenters from '../components/sections/ServiceCenters';

function ServiceCentersPage() {
  return <ServiceCenters />;
}

export default ServiceCentersPage;
